import { _axios } from "./request";
import axios from "axios"
import qs from "qs";
// 精品课程、专题训练营列表
export const getProductPageList = data => _axios.get(`/mall-client/api/product/v1/getProductPageList`, { params: data });

// 课程一级、二级分类列表
export const getProductTypeList = data => _axios.get(`/mall-client/api/product/v1/getProductTypeList`, { params: data });
// 课程所有分类列表
export const getAllClassTypeList = () => _axios.get(`/mall-client/mall/productCate/v1/getAllProductCateList`);
// 专题训练营分类列表
export const getSpecialTypeList = () => _axios.get(`/mall-client/mall/productCate/v1/getSpecialProductCateList`);
//双师专栏详情
export const getProductInfoFrontById = data => _axios.get(`/mall-client/mall/productRelationFront/api/v1/getProductInfoFrontById`, { params: data });
/* 师资团队 */
// 师资团队-名师列表
export const getTeamTeacherList = data => _axios.post(`/mall-client/teacherFront/v1/listPage`, data);
// 师资团队-名师详情
export const getTeamTeacherDetail = data => _axios.get(`/mall-client/teacherFront/v1/getTeacher`, { params: data });
// 师资团队-名师详情-教师开设的课程列表
export const getTeacherCourseList = data => _axios.get(`/mall-client/teacherFront/v1/getTeacherProduct`, { params: data });

/* 课程详情 */
// 课程详情-未登录
export const getCourseDetailNot = data => _axios.get(`/mall-client/mall/productFront/v1/getProductInfoById_NotLogin`, { params: data });
// 课程详情-已登录
export const getCourseDetail = data => _axios.get(`/mall-client/mall/productFront/api/v1/getProductInfoById`, { params: data });
// 课程详情-目录-直播
export const getCourseCatalogLive = data => _axios.get(`/mall-client/mall/courseCatalogFront/api/v1/getProductCourseLiveListByProductId`, { params: data });
// 课程详情-目录-录播
export const getCourseCatalogRecorded = data => _axios.get(`/mall-client/mall/courseCatalogFront/api/v1/getProductCourseRecordListByProductId`, { params: data });
// 添加收藏
export const addCollectionProduct = data => _axios.get(`/mall-client/mall/productFront/api/v1/addCollectionProduct`, { params: data });
// 取消收藏
export const cancelCollectionProduct = data => _axios.get(`/mall-client/mall/productFront/api/v1/cancelCollectionProduct`, { params: data });
// 课程教师列表
export const getCourseTeacher = data => _axios.post(`/mall-client/teacherFront/v1/teacherProductList`, data);
// 查询教师的推荐列表
export const teacherRecommendList = data => _axios.post(`/mall-client/teacherFront/v1/teacherRecommendList`, data);



/* 支付 */
// 下单
export const setNewOrder = data => _axios.post(`/mall-client/api/order/v1/create_order`, data);
// 获取支付方式(二维码或页面)
export const getPayWay = data => _axios.post(`/mall-client/api/v1/CallPay/api/v1/yunZhiCallPay`, data);
// 查询支付状态
export const getPayStatus = data => _axios.post(`/mall-client/api/v1/CallPay/api/v1/queryPay`, data);

/* 登录注册 */
// 注册
export const setRegistered = data => _axios.post(`/mall-client/api/member/v1/registerMember`, qs.stringify(data));
// 登录
export const setLogin = data => _axios.post(`/mall-client/api/member/v1/memberLogin`, qs.stringify(data));
// 发送验证码
export const setSendCode = data => _axios.post(`/mall-client/api/member/v1/sendCode`, qs.stringify(data));
// 修改密码
export const setResetPassword = data => _axios.post(`/mall-client/api/member/v1/updatePwd`, data);
// 忘记密码
export const setForgetPassword = data => _axios.post(`/mall-client/api/member/v1/forgetPwd`, qs.stringify(data));
// 退出
export const setLoginOut = data => _axios.post(`/mall-client/api/member/v1/memberLogout`, qs.stringify(data));
// 获取会员资料
export const getUserInfo = data => _axios.get(`/mall-client/api/member/v1/getMemberByUserId`, { params: data });



/* 个人中心 */
// 个人中心-我的课程&专题课程
export const getMineCourseList = data => _axios.get(`/mall-client/mall/productFront/v1/getProductListByUserId`, { params: data });
// 个人中心-我的收藏
export const getMineCollectList = data => _axios.get(`/mall-client/mall/productFront/v1/getYzProductCollectionList`, { params: data });
// 个人中心-我的订单
export const getMineOrderList = data => _axios.post(`/mall-client/api/order/v1/pageList`, data);
export const getMineOrderDetail = data => _axios.post(`/mall-client/api/order/v1/order_detail`, data); // 订单详情
export const getMineOrderInitiative = data => _axios.post(`/mall-client/api/v1/CallPay/cancelOrder`, data); // 主动刷新订单状态
// 个人中心-保存或更新会员个人资料
export const mineSaveOrUpdate = data => _axios.post(`/mall-client/api/member/v1/saveOrUpdate`, data);
// 个人中心-修改密码
export const mineChangePassword = data => _axios.post(`/mall-client/api/member/v1/updatePwd`, qs.stringify(data));

/* 字典表 */
// 获取行业、学历
export const dictionaryList = data => _axios.get(`/dict-service/dictCommonMain/api/v2/getDictByParentCode`, { params: data });


// solr多条件搜索
export const searchSolr = data => _axios.post(`/mall-client/mall/productSearch/searchSolr`, data);
// 楼层 分类
export const getContentByAppId = () => _axios.get(`/content/contentTypeRest/api/v1/getContentByAppId`);

// 首页推荐一级、二级分类列表
export const getProductCateRecommendList = () => _axios.get(`/mall-client/mall/productCate/v1/getProductCateRecommendList`);

// 根据二级分类ID，查询相关推荐商品
export const getProductListByCateId_2 = (data) => _axios.get(`/mall-client/mall/productFront/v1/getProductListByCateId_2`, { params: data });

// 根据一级分类ID，查询相关推荐商品
export const getProductListByCateId_1 = (data) => _axios.get(`/mall-client/mall/productFront/v1/getProductListByCateId_1`, { params: data });


// 首页推荐的 精品课程、专题训练营列表
export const getProductRecommendList = () => _axios.get(`/mall-client/mall/productFront/v1/getProductRecommendList
`);


//获取保利威签名
export const getPolyvSign = data => _axios.post(`/storage/api/v1/auth/getPolyvSign`, data);

// 获取保利威配置信息
export const queryPolyvConfigData = data => _axios.get(`/storage/api/v1/auth/getVideoAccount?accountType=1`, qs.stringify(data))

//获取聊天室的token
export const getChatToken = data => _axios.get(`/storage/api/v1/auth/getChatToken`, { params: data });

//课程详情
export const getGoodsDetail = (id, data) => axios.get(`https://open-api.ambow.com/globalte-client/product/667`, { params: data });

//获取banner
export const getbannerList = (data) => _axios.get(`/mall-client/banner/api/v1/bannerList`, { params: data });

// 保利威 直接授权
export const getIndependentAuthorization = ({ userId, timestamp }) => {
    return _axios.get(`globalte-client/member/polyv/live/getIndependentAuthorization?userId=${userId}&timestamp=${timestamp}`);
};
// 排行榜  书籍列表分类
export const getRankCourseList = data => _axios.get(`/api/v1/edu/course/list/`, { params: data });
// 排行榜  课程列表分类 学校
export const getRankCourseSchool = data => _axios.get(`/api/v1/edu/academic/school/list/`, { params: data });
// 排行榜  课程列表分类 年级
export const getRankCourseGrade = data => _axios.get(`/api/v1/edu/academic/grade/list/`, { params: data });

// 排行榜  课程列表分类 学科
export const getRankCourseSubject = data => _axios.get(`/api/v1/edu/academic/subject/list/`, { params: data });
// 首页 banner
export const getHomeBannerList = data => _axios.get(`/api/v1/edu/banner/list/`, { params: data });
// 首页 书籍分类
export const getHomeBookCat = data => _axios.get(`/api/v1/edu/book/home/cat/list`, { params: data });
// 首页 书籍列表
export const getHomeBookList = data => _axios.get(`/api/v1/edu/book/home/list/`, { params: data });

// 首页 课程分类
export const getHomeCourseCat = data => _axios.get(`/api/v1/edu/course/home/cat/list`, { params: data });
// 首页 课程列表
export const getHomeCourseList = data => _axios.get(`/api/v1/edu/course/home/list/`, { params: data });
// 排行榜  书籍列表分类
export const getRankBookCatList = data => _axios.get(`/api/v1/edu/book/cat/list/`, { params: data });

// 排行榜  书籍列表
export const getRankBookList = data => _axios.get(`/api/v1/edu/book/list/`, { params: data });

// 排行榜  app列表
export const getRankAppList = data => _axios.get(`/api/v1/edu/app/list/`, { params: data });

// 排行榜 app详情
export const getRankAppDetail = (id) => _axios.get(`/api/v1/edu/app/${id}/`);


// 获取验证码
export const getCode = data => _axios.post(`/api/v1/account/code/`, data);

// 验证码登录
export const smsLogin = data => _axios.post(`/api/v1/account/login/register/sms/`, data);

// 获取京东书籍
export const getPromotion = data => _axios.post(`/api/v1/jd/get/promotion/`, data);

// 获取年级列表
export const getGradeList = data => _axios.get(`/api/v1/account/academic/grade/list/`, { params: data });

// 设置年级列表
export const setGradeList = data => _axios.post(`/api/v1/account/academic/grade/list/`, data);

// 退出登录
export const Logout = data => _axios.get(`/api/v1/account/logout/`, { params: data });

